
















































































































import {
  IPRCSetPayload,
  RateChangesState,
  SetValuePayload
} from "@/models";
import ChangeSetQuickStats from "@/views/rate-changes/components/ChangeSetQuickStats.vue";
import RateChangesModule from "@/store/modules/rate-changes";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, State } from "vuex-class";
import moment from "moment";
import { formatDate } from "@/helpers/functions/format-date";

const rateChanges = namespace(RateChangesModule.name);

@Component({
  name: "GeneralInfo",
  components: { ChangeSetQuickStats }
})
export default class GeneralTab extends Vue {
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;
  @rateChanges.Action("updateIPRCSet") private updateIPRCSet!: (payload: IPRCSetPayload) => void;
  @rateChanges.Action("setValue") private setValue!: (payload: SetValuePayload) => void;
  // ===== Props ===== //

  // ===== Data ===== //
  private newChangeDate = moment.utc().add(1, "days").toISOString().substr(0, 10);
  private editChangeModal = false;
  private newChangeReason = "";
  private editDateModal = false;
  private minDate = moment.utc().add(1, "days").toISOString().substr(0, 10);

  // ===== Methods ===== //
  private formatDate = formatDate;
  private openChangeModal(): void {
    this.editChangeModal = true;
    this.newChangeReason = this.rateChanges.selectedIPRCSet!.description;
  }
  private updateChangeReason(): void {
    this.editChangeModal = false;
    const payload: IPRCSetPayload = {
      id: this.rateChanges.selectedIPRCSet!.id,
      description: this.newChangeReason,
      effective_date: this.newChangeDate
    };
    this.updateIPRCSet(payload);
  }
  // ===== Watchers ===== //
  @Watch("newChangeDate")
  private handleDateUpdate(date: string): void {
    const dateIsSame = moment(date).format("LL") === moment(this.rateChanges.selectedIPRCSet!.effectiveDate).format("LL");
    if (!dateIsSame) {
      const payload: IPRCSetPayload = {
        id: this.rateChanges.selectedIPRCSet!.id,
        description: this.rateChanges.selectedIPRCSet!.description,
        effective_date: date
      };
      this.updateIPRCSet(payload);
    }
  }
  // ===== Computed ===== //
  get allLedgersAppliedFormula(): boolean {
    return this.rateChanges.selectedUnits.every(ledger => ledger.formula_id !== 0);
  }
  get displayFormulasApplied(): boolean {
    if (this.rateChanges.selectedUnits.length) {
      return !!(this.rateChanges.selectedUnits.length && this.allLedgersAppliedFormula);
    }

    return !!(this.rateChanges.reviewedIPRCSetPriceChanges.length);
  }
  get editEffectiveDate(): boolean {
    return !this.errorProcessingStatus &&
      !this.pmsProcessingStatus &&
      !this.pricesUpdatedStatus &&
      !this.revertStatus &&
      !this.submittedForReviewStatus;
  }
  get errorProcessingStatus(): boolean {
    return this.selectedIPRCSetStatus.toLowerCase().includes("error process");
  }
  get formattedChangeDate(): string {
    return this.formatDate(this.newChangeDate);
  }
  get formulasApplied(): object {
    if (this.rateChanges.reviewedIPRCSetPriceChanges.length) {
      return Array.from(new Set(this.rateChanges.reviewedIPRCSetPriceChanges.map(formula => formula.formula_name))).map(name => {
        return this.rateChanges.reviewedIPRCSetPriceChanges.find(formula => formula.formula_name === name);
      });
    }

    return Array.from(new Set(this.rateChanges.selectedUnits.map(formula => formula.formula_name))).map(name => {
      return this.rateChanges.selectedUnits.find(formula => formula.formula_name === name);
    });
  }
  get pmsProcessingStatus(): boolean {
    return this.selectedIPRCSetStatus.toLowerCase().includes("pms process");
  }
  get pricesUpdatedStatus(): boolean {
    return this.selectedIPRCSetStatus.toLowerCase().includes("prices updated");
  }
  get revertStatus(): boolean {
    return this.selectedIPRCSetStatus.toLowerCase().includes("revert");
  }
  get selectedIPRCSetStatus(): string {
    return this.rateChanges.selectedIPRCSet! && this.rateChanges.selectedIPRCSet!.status;
  }
  get submittedForReviewStatus(): boolean {
    return this.selectedIPRCSetStatus.toLowerCase().includes("submitted for review");
  }
  // ===== Lifecycle Hooks ===== //
  private mounted(): void {
    this.newChangeDate = moment.utc(this.rateChanges.selectedIPRCSet!.effectiveDate)
      .toISOString().substr(0, 10);
  }
}
